import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchProducts } from '../../store/actions/productActions';
import { createUser } from '../../store/actions/userActions';
import { FiSliders, FiRotateCcw, FiList, FiGrid } from 'react-icons/fi';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import SingleProduct from './SingleProduct/SingleProduct';
import Spinner from '../UIComponents/Spinner';
import lang from './lang';
import './Products.css';
import { firestore } from '../../config/firebase';

class Products extends Component {
    state = {
        display: 'none',
        totalItems: 0,
        currentData: [],
        pageSize: 16,
        brands: [],
        colors: [],
        sizes: [],
        quality: [],
        list: false,
        filters: false,
        sortBy: { color: '', brand: '', quality: '', dimensions: '' },
        sortingIsActive: false
    }
    componentDidMount() {
        this.initalSortedData();

        // setTimeout(() => {
        //     firestore
        //         .collection('users')
        //         .doc(this.props.user.id)
        //         .collection('products')
        //         .get()
        //         .then(doc => {
        //             // If current number of products is not equal on databae fetch products
        //             if (doc.size !== this.props.products.length) {
        //                 // Get All Products
        //                 firestore
        //                     .collection('users')
        //                     .doc(this.props.user.id)
        //                     .collection('products')
        //                     .orderBy("updatedAt", "desc")
        //                     .get().then(doc => {
        //                         const products = doc.docs.map(item => ({ id: item.id, ...item.data() }));
        //                         this.props.fetchProducts(products);
        //                     }).catch(err => console.log(err))
        //             }
        //         })
        //         .catch(err => console.log(err));
        // }, 1000)

        this.setState({ list: this.props.user.productViewlist || false, pageSize: this.props.user.productViewlist ? 20 : 12 });
        firestore
            .collection('users')
            .doc(this.props.user.id)
            .collection('products')
            .onSnapshot((doc) => {
                let products = [];
                doc.forEach(item => products.push({ ...item.data(), id: item.id }))
                this.props.fetchProducts(products);
            });
    }

    initalSortedData = () => {
        let data = { brands: {}, colors: {}, quality: {}, sizes: {} };
        const { brands, colors, quality, sizes } = data;
        this.props.products.forEach(item => {
            if (!brands[item.brand.toLowerCase()] && item.brand !== '') {
                brands[item.brand] = true
            }
            if (!brands[item.brand.toLowerCase()] && item.brand !== '') {
                brands[item.brand] = true
            }
            if (!colors[item.color.toLowerCase()] && item.color !== '') {
                colors[item.color] = true
            }
            if (!quality[item.quality.toLowerCase()] && item.quality !== '') {
                quality[item.quality] = true
            }
            if (!sizes[item.dimensions] && item.dimensions !== '') {
                sizes[item.dimensions] = true
            }
        });
        const brandSort = Object.keys(brands).sort();
        const colorSort = Object.keys(colors).sort((a, b) => a - b);
        const sizeSort = Object.keys(sizes).sort((a, b) => a - b);
        const qualitySort = Object.keys(quality).sort();

        this.setState({
            totalItems: this.props.products.length,
            currentData: this.props.products.slice(0, this.state.pageSize),
            brands: brandSort,
            colors: colorSort,
            sizes: sizeSort,
            quality: qualitySort,
            sortBy: { color: '', brand: '', quality: '', dimensions: '' },
            sortingIsActive: false
        })
    }

    filterHandler = () => {
        this.setState(prevState => {
            return { filters: !prevState.filters }
        });
    }

    pageHandler = (page) => {
        const startPosition = this.state.pageSize * page - this.state.pageSize;
        const endPosition = (this.state.pageSize * page) <= this.state.totalItems ? (this.state.pageSize * page) : this.state.totalItems;
        this.setState({
            currentData: this.props.products.slice(startPosition, endPosition)
        })
    }

    filterInputHandler = (e) => {
        const { value, name } = e.target;
        this.setState({ sortingIsActive: true, sortBy: { ...this.state.sortBy, [name]: value } }, () => {
            this.sortByBrand();
            const capitalizeLetter = name.charAt(0).toUpperCase() + name.slice(1);
            const currentDataList = this[`filter${capitalizeLetter}DataListRef`].children;

            for (let i = 0; i < currentDataList.length; i++) {
                if (currentDataList[i].value === value) {
                    return this[`filter${capitalizeLetter}Ref`].blur()
                }
            }
        })
    }

    componentDidUpdate(prevProps) {
        // Update state if props are updated
        if (prevProps.products.length !== this.props.products.length) {
            this.initalSortedData()
        } else if (prevProps.user.productViewlist !== this.props.user.productViewlist) {
            this.setState({ list: this.props.user.productViewlist })
        }

    }
    sortByBrand = () => {
        let data = [];
        const { sortBy } = this.state;
        const activeFileds = Object.keys(sortBy).filter(item => sortBy[item] !== '');

        if (activeFileds.length === 0) {
            data = this.props.products
        } else if (activeFileds.length === 1) {
            data = this.props.products.filter(item => {
                return item[activeFileds[0]].includes(sortBy[activeFileds[0]])
            });
        } else if (activeFileds.length === 2) {
            data = this.props.products.filter(item => {
                return item[activeFileds[0]].includes(sortBy[activeFileds[0]]) && item[activeFileds[1]].includes(sortBy[activeFileds[1]])
            });
        } else if (activeFileds.length === 3) {
            data = this.props.products.filter(item => {
                return (item[activeFileds[0]].includes(sortBy[activeFileds[0]])
                    && item[activeFileds[1]].includes(sortBy[activeFileds[1]])
                    && item[activeFileds[2]].includes(sortBy[activeFileds[2]])
                )
            });
        } else {
            data = this.props.products.filter(item => {
                return (item[activeFileds[0]].includes(sortBy[activeFileds[0]])
                    && item[activeFileds[1]].includes(sortBy[activeFileds[1]])
                    && item[activeFileds[2]].includes(sortBy[activeFileds[2]])
                    && item[activeFileds[3]].includes(sortBy[activeFileds[3]])
                )
            });
        }

        let sortNames = { brands: {}, colors: {}, quality: {}, sizes: {} };
        const { brands, colors, quality, sizes } = sortNames;
        data.forEach(item => {
            if (!brands[item.brand.toLowerCase()] && item.brand !== '') {
                brands[item.brand] = true
            }
            if (!brands[item.brand.toLowerCase()] && item.brand !== '') {
                brands[item.brand] = true
            }
            if (!colors[item.color.toLowerCase()] && item.color !== '') {
                colors[item.color] = true
            }
            if (!quality[item.quality.toLowerCase()] && item.quality !== '') {
                quality[item.quality] = true
            }
            if (!sizes[item.dimensions] && item.dimensions !== '') {
                sizes[item.dimensions] = true
            }
        });
        const brandSort = Object.keys(brands).sort();
        const colorSort = Object.keys(colors).sort((a, b) => a - b);
        const sizeSort = Object.keys(sizes).sort((a, b) => a - b);
        const qualitySort = Object.keys(quality).sort();

        this.setState({
            totalItems: data.length,
            currentData: data.slice(0, this.state.pageSize),
            brands: brandSort,
            colors: colorSort,
            sizes: sizeSort,
            quality: qualitySort
        });
    }

    resetFiltersHandler = () => {
        this.initalSortedData();
        this.filterBrandRef.value = '';
        this.filterDimensionsRef.value = '';
        this.filterQualityRef.value = '';
        this.filterColorRef.value = '';
    }

    redirectHandler = (id) => {
        this.props.history.push(`/products/${id}`);
    }

    productViewHandler = (val) => {
        console.log(val);

        this.setState({ list: val });
        this.props.createUser({ ...this.props.user, productViewlist: val });
        firestore
            .doc('users/' + this.props.user.id)
            .update({ productViewlist: val });

    }



    render() {
        const { alert, button, filters, table } = lang[this.props.user.lang || 'en'];
        console.log(button);


        if (this.props.products.length !== 0) {
            return (
                <div id="products">
                    <Spinner display={this.state.display} />
                    <div className="d-flex justify-content-between mb-4 filter-btn">
                        <button
                            className={`btn btn-outline-secondary rounded-pill px-4 ${this.state.filters ? 'active' : ''}`}
                            onClick={this.filterHandler}
                        >
                            {filters.title}
                            <FiSliders className="ml-2" />
                        </button>
                        {
                            this.props.auth.isAdmin ?
                                (<Link to="/new-product" className="btn btn-outline-success rounded-pill px-4">+ {button}</Link>)
                                :
                                null
                        }

                    </div>
                    <div id="product-filters" style={{ display: this.state.filters ? 'flex' : 'none' }} className="rounded px-3 shadow-sm bg-white">
                        <div className="my-2 w-100">
                            <div className="form-row">
                                <div className="form-group col-sm-6 col-md-3">
                                    <label>{filters.brand.title}</label>
                                    <input
                                        list="brands-list"
                                        name="brand"
                                        onChange={(event) => this.filterInputHandler(event)}
                                        className="form-control"
                                        ref={ref => this.filterBrandRef = ref}
                                    />
                                    <datalist id="brands-list" ref={ref => this.filterBrandDataListRef = ref}>
                                        {
                                            this.state.brands.map(item => {
                                                return <option value={item} key={item} />
                                            })
                                        }
                                    </datalist>
                                </div>
                                <div className="form-group col-sm-6 col-md-3">
                                    <label>{filters.size.title}</label>
                                    <input
                                        list="sizes-list"
                                        name="dimensions"
                                        onChange={(event) => this.filterInputHandler(event)}
                                        className="form-control"
                                        ref={ref => this.filterDimensionsRef = ref}
                                    />
                                    <datalist id="sizes-list" ref={ref => this.filterDimensionsDataListRef = ref}>
                                        {
                                            this.state.sizes.map(item => {
                                                return <option value={item} key={item} />
                                            })
                                        }
                                    </datalist>
                                </div>
                                <div className="form-group col-sm-6 col-md-3">
                                    <label>{filters.quality.title}</label>
                                    <input
                                        list="quality-list"
                                        name="quality"
                                        onChange={(event) => this.filterInputHandler(event)}
                                        className="form-control"
                                        ref={ref => this.filterQualityRef = ref}
                                    />
                                    <datalist id="quality-list" ref={ref => this.filterQualityDataListRef = ref}>
                                        {
                                            this.state.quality.map(item => {
                                                return <option value={item} key={item} />
                                            })
                                        }
                                    </datalist>
                                </div>
                                <div className="form-group col-sm-6 col-md-3">
                                    <label>{filters.color.title}</label>
                                    <input
                                        list="colors-list"
                                        name="color"
                                        onChange={(event) => this.filterInputHandler(event)}
                                        className="form-control"
                                        ref={ref => this.filterColorRef = ref}
                                    />
                                    <datalist id="colors-list" ref={ref => this.filterColorDataListRef = ref}>
                                        {
                                            this.state.colors.map(item => {
                                                return <option value={item} key={item} />
                                            })
                                        }
                                    </datalist>
                                </div>
                                <span className="btn btn-sm btn-success" onClick={this.resetFiltersHandler}>Reset <FiRotateCcw /> </span>
                            </div>

                        </div>
                    </div>

                    <div id="sort-by-list" className="text-right mb-3">
                        <span className={`hover ${this.state.list ? 'active' : ''}`} onClick={(val) => this.productViewHandler(true)}><FiList /></span>
                        <span className={`hover ${!this.state.list ? 'active' : ''}`} onClick={(val) => this.productViewHandler(false)}><FiGrid /> </span>
                    </div>
                    <div className="row">
                        {!this.state.list ?
                            this.state.currentData.map((item) => {
                                return <SingleProduct
                                    data={item}
                                    key={item.id}
                                    currency={this.props.user.currency}
                                    lang={this.props.user.lang}
                                    rate={this.props.user.uzsAmount}
                                    list={false}
                                />
                            })
                            :
                            <table className="table table-striped table-responsive-md text-center">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>{table.img}</th>
                                        <th>{table.name}</th>
                                        <th>{table.code}</th>
                                        <th>{table.dimensions}</th>
                                        <th>{table.quality}</th>
                                        <th>{table.quantity}</th>
                                        <th>{table.color}</th>
                                        <th>{table.action}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentData.map((item, index) => {
                                        return <SingleProduct
                                            data={item}
                                            index={index + 1}
                                            key={item.id}
                                            currency={this.props.user.currency}
                                            lang={this.props.user.lang}
                                            rate={this.props.user.uzsAmount}
                                            redirect={this.redirectHandler}
                                            list={true}
                                        />
                                    })}
                                </tbody>
                            </table>
                        }

                        {
                            this.state.currentData.length === 0 && this.state.sortingIsActive ?
                                (
                                    <div className="alert alert-dark w-100 text-center mt-5" role="alert">
                                        Sorry! Nothing has found by your request.
                                    </div>
                                )
                                :
                                null
                        }
                    </div>

                    <Pagination
                        showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                        total={this.state.totalItems}
                        pageSize={this.state.pageSize}
                        onChange={(page) => this.pageHandler(page)}
                        hideOnSinglePage={true}
                    />
                </div>
            );
        } else {
            return (
                <div className="jumbotron text-center">
                    <h1>{alert.title}</h1>
                    <p className="lead mt-5 mb-3">{alert.content}</p>
                    <Link to="/new-product" className="btn btn-primary">{alert.button} +</Link>
                </div>
            );
        }

    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        user: state.user,
        currency: state.currency,
        products: state.products.products.sort((a, b) => b.updatedAt - a.updatedAt)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchProducts: (products) => dispatch(fetchProducts(products)),
        createUser: (data) => dispatch(createUser(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Products);